const KEEP_AWAKE_LOCK_NAME = "screener-keep-awake";

/**
 * Держит Web Lock, пока включён поток. Chrome замораживает фоновую вкладку и
 * она перестаёт читать websocket: демон рвёт связь как «клиент отстал», а
 * звуковые алерты §8 в фоне молчат (разбор 14.10.2026). Страницы, держащие
 * блокировку, браузер не замораживает.
 *
 * Это обход по эвристике браузера, а не гарантия: правила заморозки вправе
 * измениться. Режим `shared` — чтобы несколько вкладок не ждали друг друга.
 *
 * Без `navigator.locks` ничего не делает. Возвращает функцию, отпускающую
 * блокировку; повторный вызов безопасен, а отпуск до выдачи блокировки
 * срабатывает сразу, как только её выдадут.
 */
export function holdKeepAwakeLock(locks: LockManager | undefined = globalThis.navigator?.locks) {
  if (!locks) {
    return () => {};
  }

  let release: (() => void) | undefined;
  let released = false;

  locks
    .request(
      KEEP_AWAKE_LOCK_NAME,
      { mode: "shared" },
      () =>
        new Promise<void>((resolve) => {
          if (released) {
            resolve();
            return;
          }
          release = resolve;
        }),
    )
    .catch(() => {});

  return () => {
    released = true;
    release?.();
    release = undefined;
  };
}
